<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-screenshot`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.441 5.624l.095.083 14.399 14.4 14.4-14.4a1 1 0 011.414 0l1.414 1.414a1 1 0 010 1.415l-14.4 14.398 5.173 5.174a8 8 0 11-2.828 2.828l-5.173-5.173-5.092 5.091a8 8 0 11-2.861-2.794l5.124-5.126L6.707 8.535a1 1 0 01-.083-1.32l.083-.094 1.414-1.414a1 1 0 011.219-.152l.101.069zM36 31a4 4 0 100 8 4 4 0 000-8zm-24 0a4 4 0 100 8 4 4 0 000-8z"/></svg>
</template>
<script>

export default {
  name: 'IconScreenshot',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
